export const NAMESPACE = 'oportun'